const getters = {
  clientGeneralView(state) {
    return state.client.general;
  },

  clientExcursionManagementView(state) {
    return state.client.excursionManagement;
  },

  clientExcursionManagementVendorsListView(state) {
    return state.client.excursionManagementVendorsList;
  },

  clientContentEngineView(state) {
    return state.client.contentEngine;
  },

  clientProviderView(state) {
    return state.client.provider;
  },

  clientStudentManagementView(state) {
    return state.client.studentManagement;
  }
};

export default getters;
